import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportTemplateFieldDefinition, ReportTemplateFieldType } from 'src/dto/report-template';
import { v4 as uuidv4 } from 'uuid';
import { NgClass, AsyncPipe } from '@angular/common';
import { MatList, MatListItem } from '@angular/material/list';
import { CdkDropList, CdkDrag, CdkDragPlaceholder, CdkDragPreview } from '@angular/cdk/drag-drop';
import { ChipV2Module } from '@schenck/rotec-components';
import { TemplateToolboxItemComponent } from '../template-toolbox-item/template-toolbox-item.component';
import { TranslateDirective } from '@ngx-translate/core';
import { BisectAsyncPipe } from '../../../../../pipes/bisect-async.pipe';

@Component({
  selector: 'rc-template-toolbox-category',
  templateUrl: './template-toolbox-category.component.html',
  styleUrls: ['./template-toolbox-category.component.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgClass,
    MatList,
    CdkDropList,
    MatListItem,
    CdkDrag,
    CdkDragPlaceholder,
    ChipV2Module,
    TemplateToolboxItemComponent,
    CdkDragPreview,
    TranslateDirective,
    AsyncPipe,
    BisectAsyncPipe
],
})
export class TemplateToolboxCategoryComponent {
  @Input() fieldDefinitions$: Observable<ReportTemplateFieldDefinition[]>;
  @Input() useCustomListItemHeight = false;
  @Input() isLogo = false;

  toolboxId: string;

  ReportTemplateFieldType = ReportTemplateFieldType;

  constructor() {
    this.toolboxId = uuidv4();
  }

  preventDrop(): boolean {
    return false;
  }
}
